{
  "help": "Ajuda",
  "info": "Informações"
}
